// src/components/Inventory/InventoryModal.jsx
// Modal component for adding/editing inventory locations

import React, { useState, useEffect } from 'react';

/**
 * InventoryModal Component
 * A modal dialog for creating or editing inventory locations
 * 
 * @param {boolean} isOpen - Controls whether modal is visible
 * @param {Function} onClose - Callback when modal should close
 * @param {Function} onSave - Callback when form is submitted
 * @param {Object} inventory - Existing inventory data (for edit mode)
 * @param {boolean} isSaving - Whether save operation is in progress
 */
const InventoryModal = ({ isOpen, onClose, onSave, inventory, isSaving }) => {
  
  // Form state - stores all input values
  const [formData, setFormData] = useState({
    name: '',
   
   
    type: '',
     isActive: true   // ✅ default true
   
    
  });

  /**
   * When inventory prop changes (for editing), update the form
   * This runs when component mounts or when 'inventory' changes
   */
  useEffect(() => {
    if (inventory) {
      // Edit mode - populate form with existing data
      setFormData({
        name: inventory.name || '',
        
        
        type: inventory.type || '',
         isActive: inventory.isActive ?? true   // ✅ default true
      });
    } else {
      // Add mode - clear the form
      setFormData({
        name: '',
       
        type: '',
         isActive: formData.isActive
      });
    }
  }, [inventory]);

  /**
   * Handle input changes
   * Updates formData state when user types in any field
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
    const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  /**
   * Handle form submission
   */
 const handleSubmit = async (e) => 
  {console.log("UPDATE PAYLOAD:", formData);

  
  e.preventDefault();

  if (!formData.name.trim() || !formData.type) {
    alert('Please fill out all required fields (Name and Type)');
    return;
  }

  await onSave(formData); // assume save succeeds

  // ✅ Clear ONLY the "from" field after save (add mode)
  if (!inventory) {
    setFormData(prev => ({
      ...prev,
      from: ''
    }));
  }
};

  /**
   * Handle modal close
   */
const handleClose = () => {
  if (isSaving) return;

  setFormData(prev => ({
    ...prev,
    from: ''
  }));

  onClose();
};

  // Don't render anything if modal is not open
  if (!isOpen) {
    return null;
  }

  return (
    <div className="inventory-modal-overlay">
      <div className="inventory-modal-content">
        
        {/* Modal Header */}
        <header className="inventory-modal-header">
          <h3 className="inventory-modal-title">
            {inventory ? `Edit Inventory: ${inventory.name}` : 'Add New Inventory Location'}
          </h3>
          <button 
            className="inventory-close-modal-btn"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            ×
          </button>
        </header>

        {/* Modal Body - The Form */}
        <div className="inventory-modal-body">
          <form id="inventoryForm" onSubmit={handleSubmit}>
            <div className="inventory-form-grid">
              
              {/* Inventory Name Field */}
              <label htmlFor="name">
                Inventory Name <span style={{color: 'red'}}>*</span>
              </label>
              <input 
                type="text"
                id="name"
                name="name"
                className="inventory-custom-input"
                placeholder="e.g., Lorry 1, Main Warehouse"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isSaving}
              />

              {/* Type Field */}
              <label htmlFor="type">
                Type <span style={{color: 'red'}}>*</span>
              </label>
              <select 
                id="type"
                name="type"
                className="inventory-custom-select"
                value={formData.type}
                onChange={handleChange}
                required
                disabled={isSaving}
              >
                <option value="">Select Type</option>
                <option value="VEHICLE">VEHICLE</option>
                <option value="WAREHOUSE"> WAREHOUSE</option>
              </select>

              {/* Manager Field
              <label htmlFor="from">From</label>
              <input 
                type="text"
                id="from"
                name="from"
                className="inventory-custom-input"
                placeholder="From"
                value={formData.from}
                onChange={handleChange}
                disabled={isSaving}
              /> */}

              {/* Description Field
              <label htmlFor="to">To</label>
              <input
                id="to"
                name="to"
                className="inventory-custom-input"
                
                placeholder="To"
                value={formData.to}
                onChange={handleChange}
                disabled={isSaving}
              /> */}
              <label htmlFor="isActive">Active</label>
              <input
                type="checkbox"
                id="isActive"
                name="isActive"
                checked={formData.isActive}
                onChange={handleCheckboxChange}
                disabled={isSaving}
              />
            </div>
          

        {/* Modal Footer - Action Buttons */}
         <footer className="inventory-modal-footer">
            <button
              className="inventory-btn inventory-btn-cancel"
              onClick={handleClose}
              disabled={isSaving}
              type="button"
            >
              Cancel
            </button>

            <button
              className="inventory-btn inventory-btn-save"
              disabled={isSaving}
              type="submit"
            >
              {isSaving ? 'Saving...' : 'Save Inventory'}
            </button>
          </footer>
        </form>
        </div>
      </div>
    </div>
  );
};

export default InventoryModal;